import {
  Box,
  DialogActions,
  DialogContent,
  FormControlLabel,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Check } from "@mui/icons-material";
import { CustomBtn, SecondaryBtn } from "../../Common/CustomBtn";
import { CustomInput } from "../../Common/CustomInputs";
import {
  StyledDialog,
  StyledDialogTitle,
  StyledRadio,
  StyledRadioGroup,
  StyledActionsWrapper,
  LESSON_INPUT_PROPS,
} from "./ConfirmationDialog.styles";
import {
  START_OPTION,
  DEFAULT_START_OPTION,
  LESSON_NUMBER_LIMITS,
} from "./ConfirmationDialog.constants";

const ConfirmationDialog = ({
  open,
  handleClose,
  onSave,
  title,
  startingLesson,
  setStartingLesson,
}) => {
  const [selectedOption, setSelectedOption] = useState(DEFAULT_START_OPTION);

  useEffect(() => {
    if (!open) {
      setSelectedOption(DEFAULT_START_OPTION);
    }
  }, [open]);

  const handleOptionChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    setStartingLesson(value === START_OPTION.DAILY ? 1 : "");
  };

  const showLessonInput = selectedOption === START_OPTION.LESSON_NUMBER;

  return (
    <StyledDialog open={open} onClose={handleClose}>
      <StyledDialogTitle>{title}</StyledDialogTitle>

      <DialogContent>
        <Box>
          <StyledRadioGroup
            value={selectedOption}
            onChange={handleOptionChange}
          >
            <FormControlLabel
              value={START_OPTION.DAILY}
              control={<StyledRadio />}
              label="Start from lesson number 1"
            />
            <FormControlLabel
              value={START_OPTION.LESSON_NUMBER}
              control={<StyledRadio />}
              label="Show Lessons Starting from Lesson Number"
            />
          </StyledRadioGroup>

          {showLessonInput && (
            <CustomInput
              label="Lesson Number"
              placeholder="Enter Lesson Number"
              type="number"
              value={startingLesson}
              setValue={setStartingLesson}
              limit
              min={LESSON_NUMBER_LIMITS.MIN}
              max={LESSON_NUMBER_LIMITS.MAX}
              noIcon
              {...LESSON_INPUT_PROPS}
            />
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <StyledActionsWrapper>
          <SecondaryBtn
            smallR
            text="Cancel"
            noIcon
            width="35%"
            onClick={handleClose}
          />
          <CustomBtn
            smallR
            text="Yes"
            Icon={Check}
            width="35%"
            onClick={onSave}
          />
        </StyledActionsWrapper>
      </DialogActions>
    </StyledDialog>
  );
};

export default ConfirmationDialog;
